var map = {
	"./img22-1.png": 58219,
	"./img22.png": 37018,
	"./tips.png": 28768,
	"./tips1.png": 2082,
	"./tips10.png": 31074,
	"./tips11.png": 37524,
	"./tips12.png": 9206,
	"./tips2.png": 7259,
	"./tips3.png": 88069,
	"./tips4.png": 13817,
	"./tips5.png": 57525,
	"./tips6.png": 29351,
	"./tips7.png": 7886,
	"./tips8.png": 7647,
	"./tips9.png": 24459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66636;